import { IconExternal } from '@components/icons';
import { useLatestTx } from '@components/store/getters';
import Link from '@components/common/Link';

export default function ProcessingModal() {
  const latestTx = useLatestTx();

  return (
    <>
      <p>
        If you close this window, your transaction will still process. Your new position will appear on your Dashboard
        after processing.
      </p>
      <p>
        <Link href={`https://etherscan.io/tx/${latestTx}`} variant="outline">
          View Transaction on Etherscan
          <IconExternal />
        </Link>
      </p>
    </>
  );
}
